import DOMPurify from "dompurify";

// Centralized HTML sanitizer for any dangerouslySetInnerHTML sink.
// Strips script/event handlers/javascript: URLs and other XSS vectors.
export const safeHtml = (html: string | null | undefined): string =>
  DOMPurify.sanitize(html ?? "");

// Allowlist of URL schemes safe for href/src in user-rendered content.
// Anything else (javascript:, data:, vbscript:, file:, ...) is rejected.
const SAFE_URL_PROTOCOLS = new Set(["http:", "https:", "mailto:"]);

export const safeUrl = (url: string | null | undefined): string | null => {
  if (!url) return null;
  const trimmed = url.trim();
  if (!trimmed) return null;
  try {
    const parsed = new URL(trimmed, window.location.href);
    return SAFE_URL_PROTOCOLS.has(parsed.protocol) ? trimmed : null;
  } catch {
    return null;
  }
};
